var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.667,
    width: 45.333,
    height: 30.667,
    rx: 4.667,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 1.333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 21.678h-2.827l-2.12-8.088c-.1-.372-.314-.701-.628-.856a9.2 9.2 0 00-2.592-.856v-.311h4.554c.629 0 1.1.467 1.179 1.01l1.1 5.835 2.826-6.845h2.748l-4.24 10.11zm5.811 0h-2.67l2.2-10.111h2.669l-2.199 10.11zm5.653-7.31c.079-.545.55-.856 1.1-.856a4.974 4.974 0 012.592.466l.471-2.177a6.758 6.758 0 00-2.434-.468c-2.591 0-4.477 1.4-4.477 3.345 0 1.478 1.335 2.255 2.278 2.723 1.02.466 1.413.777 1.335 1.244 0 .7-.786 1.01-1.57 1.01-.943 0-1.886-.233-2.749-.622l-.471 2.178c.942.389 1.962.545 2.905.545 2.906.077 4.712-1.323 4.712-3.423 0-2.644-3.692-2.8-3.692-3.965zM39 21.678l-2.12-10.111h-2.277c-.472 0-.943.311-1.1.777l-3.926 9.334h2.749l.548-1.478h3.377l.315 1.478H39zm-4.005-7.389l.785 3.811H33.58l1.414-3.81z",
    fill: "#172B85"
  })));
}
export default SvgVisa;